import { render, staticRenderFns } from "./ActRec.vue?vue&type=template&id=26697085"
import script from "./ActRec.vue?vue&type=script&lang=js"
export * from "./ActRec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports